module.exports = require("yaml-js");


//////////////////
// WEBPACK FOOTER
// external "yaml-js"
// module id = 537
// module chunks = 0